import React, { useState } from 'react';
import "./index.css";
import parse from "html-react-parser"

const userIcon = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABmJLR0QA/wD/AP+gvaeTAAABUElEQVRIia3WyypFURzH8Q+RKFGimJBMZKBQBmYuD2Bu4lK8gJlXUAwMvYYyMTAwEQZKiULIZcBAKcllsM4pnc46e2nvX/3au7X2/n33Xpd/izRNYRcPuMAm2hLfTdYCvvFT4RscYLYISA/eq0D++hMjWUH1Gf1LaM54pgHLeUGTWQEljeUF9SeCOvOCvhJB73lBh4mgs7yg7kRQV15QeyIo9xwdJ4L2E5+LakAoObU27JX0Ia6p+QzQShEQaBGKaTXIPVqLAsFcBLSYGpC1GMp6ibSfpoKyNIRVPKr+R89YxzSa/hveIAzJZSQ85hesSZyzUZz/E1DpJ8zUggzjLSek7A9MxEA7BUHK3ouBbgsG3f0Nr4/cF6G6GKiwPSGcmrZinR3Yln3qqeVrbGCwMryuskE49YwLlbsPvaWPaBTqXpOwZ15L1zuc4EhY2lX1C/iXuBtRk3hsAAAAAElFTkSuQmCC`;

const passwordIcon = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABmJLR0QA/wD/AP+gvaeTAAABHUlEQVRIic2VQWrCQBSGP0VSEKHg2lD1HAq9Rem2duei10i9hmeQUnAtuHZT6NboQrrSgN0YFxp4iHnjzETxwYPAfPN/mUkyAft6Aj6BGbAGNsfrAdB0yDtbPSAB0pxOgDdfySuwUyRZ74AXV0kd+BNhU+AZqB67C0zE+Ap4dBF9iJBfoHaGqQI/guu7iL5FwLvC9QQ3chEtRUBL4dqCm7uI/kVAoHAPgtvKgdKFotRijg172wo4nAALzN9OXsdAhL7dRB6C0440kc9KTnupPaxUGbOucpFh1xKNgAYQAl8+N2Ha94ZgQxPvs6Ig59q6TCsaC3Zs4n3fumy+kb3ZW1fxnN/hwoPzLj7YRYGeWBMNCxSpWQGHUzemgN/EHtOMriKlrZeFAAAAAElFTkSuQmCC`;

const INSTANCES = ['revmort', 'revmort1', 'revmort7', 'revmort8', 'revmort9'];

const Login = ({ location, whlDisclaimer }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });

  const path = location?.split('/')[1];
  const ssInstance = INSTANCES[Math.floor(Math.random() * INSTANCES.length)];

  const baseUrls = {
    ss: `https://${ssInstance}.reversesoftonline.com/ReverseMortgage/jsp/login.jsf`,
    smls: 'https://seemyloanstatus.com/ReverseMortgage/jsp/extSeeMyLoanStatusPostLogin.jsf'
  };
  const [validationErrors, setValidationErrors] = useState({
    username: false,
    password: false
  });
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default behavior
    const newValidationErrors = {
      username: !formData.username,
      password: !formData.password
    };
    
    setValidationErrors(newValidationErrors);
    if (!formData.username || !formData.password) {
      alert('Enter username/password');
      return;
    }

    // Use a ref instead of querying DOM directly
    document.getElementById('loginform').submit();

    setTimeout(() => {
      setFormData({ username: '', password: '' });
      setValidationErrors({ username: false, password: false });
    }, 100);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const fieldName = name.toLowerCase() === 'userid' ? 'username' : 'password';
    
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
    
    // Clear validation error when user starts typing
    if (value) {
      setValidationErrors(prev => ({
        ...prev,
        [fieldName]: false
      }));
    }
  };

  return (
        <div className="login-wrapper">
          <div className="login-card">
          <form
            className="login-form"
            method="post"
            id="loginform"
            name="loginform"
            action={path === 'sunsoft-login' ? baseUrls.ss : baseUrls.smls}
            onSubmit={handleSubmit}
          >
            <div>
            <div className={`login-input-group ${validationErrors.username ? 'has-error' : ''}`}>
            <span className="login-icon-container">
              <img src={userIcon} alt="User icon" className="w-6 h-6" />
            </span>
            <input
              type="text"
              name={path === 'sunsoft-login' ? 'UserId' : 'userId'}
              className={`login-input ${validationErrors.username ? 'error-input' : ''}`}
              placeholder={whlDisclaimer ? 'SunSoft User ID*' : 'Username'}
              minLength="4"
              maxLength="40"
              value={formData.username}
              pattern="^[a-zA-Z0-9.\-]+$"
              autoComplete="off"
              onChange={handleChange}
            />
            {validationErrors.username && (
              <div className="validation-tooltip">
                <span className="validation-icon">!</span>
                <span className="validation-message">Please fill out this field.</span>
              </div>
            )}
          </div>
              <div className="login-input-group password-group">
                <span className="login-icon-container">
                  <img src={passwordIcon} alt="Password icon" className="w-6 h-6" />
                </span>
                <input
                  type="password"
                  name={path === 'sunsoft-login' ? 'Password' : 'password'}
                  className="login-input"
                  placeholder={whlDisclaimer ? 'SunSoft Password*' : 'Password'}
                  value={formData.password}
                  autoComplete="off"
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Hidden Fields */}
            <input type="hidden" name="autoLogin" value="true" />
            <input type="hidden" name="loginType" value="originator" />
            <input type="hidden" name="action" value="checkLoan" />
            {whlDisclaimer &&
              <p className="whl-help-text">
                {parse(whlDisclaimer)}
              </p>
            }
            <div className="login-button-container">
              <button type="submit" className="login-submit-button">
                Submit
              </button>
            </div>
          </form>
          </div>
        </div>
  );
};

export default Login;
